import { Helmet } from "react-helmet-async";
import { useI18n } from "../lib/i18n";
import { mediaUrl } from "../lib/api";

export default function Seo({ title, description, image, type = "website", jsonLd, seo }) {
  const { lang, tr } = useI18n();
  const ttl = (seo && tr(seo, "title")) || title;
  const desc = (seo && tr(seo, "description")) || description;
  const img = mediaUrl((seo && seo.og_image) || image);
  const full = ttl ? (ttl.includes("Landmark Future") || ttl.includes("لاندمارك") ? ttl : `${ttl} | Landmark Future`) : "Landmark Future Real Estate Development";
  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{full}</title>
      {desc && <meta name="description" content={desc} />}
      <meta property="og:title" content={full} />
      {desc && <meta property="og:description" content={desc} />}
      {img && <meta property="og:image" content={img} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:locale" content={lang === "ar" ? "ar_SA" : "en_US"} />
      <meta name="twitter:card" content="summary_large_image" />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
